import styled from 'styled-components';
import Colors from 'constants/Colors';
import { FontWeight } from 'components/Text';
import Label from 'components/Form/Label';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  padding: 10px 0px 10px 0px;
  margin: 0px 0px 0px 10px;
`;

export const Text = styled.text`
  color: ${Colors.PRIMARY1} !important;
  font-weight: ${FontWeight.SemiBold};
  text-transform: uppercase;
  font-size: 16px;
`;

export const Label1 = styled(Label)`
  color: ${Colors.TEALCOLOR} !important;
  font-weight: ${FontWeight.Bold};
  font-size: 14px;
  margin-top: 16px; 
`;